import React from 'react';

import { convertStyleData } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import './FilterCustomComponent.less';

export default class FilterCustomComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  // 筛选组件 综合排序tab = 0
  sortByDefault = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newdata = {};
    let addGroup_object = pageInstance.data.eles[compindex].customFeature.addGroup_object;

    let goods_compindex = app.findComponentIndexById(addGroup_object);
    if (goods_compindex === -1) {
      app.showModal({
        content: '找不到关联的列表'
      });
      return;
    }
    
    let param = pageInstance.data.eles[goods_compindex].param;
    param.sort_key = '';
    param.sort_direction = '';

    newdata['eles[' + compindex + '].tab'] = 0;
    newdata['eles[' + compindex + '].sortKey'] = '';
    newdata['eles[' + compindex + '].sortDirection'] = '';
    newdata['eles[' + goods_compindex + '].curpage'] = 0;
    newdata['eles[' + goods_compindex + '].is_more'] = 1;
    newdata['eles[' + goods_compindex + '].goods_data'] = [];
    newdata['eles[' + goods_compindex + '].param'] = param;

    pageInstance.setData(newdata);

    pageInstance.callComponentMethod({
      componentIndex: goods_compindex,
      methodName: '_goodsScrollFunc',
      argvs: [goods_compindex]
    });

  }

  // 筛选组件 按销量排序 tab = 1
  sortBySales = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newdata = {};
    let addGroup_object = pageInstance.data.eles[compindex].customFeature.addGroup_object;

    let goods_compindex = app.findComponentIndexById(addGroup_object);
    if (goods_compindex === -1) {
      app.showModal({
        content: '找不到关联的列表'
      });
      return;
    }
    let param = pageInstance.data.eles[goods_compindex].param;
    param.sort_key = 'sales';
    param.sort_direction = 0;
    
    newdata['eles[' + compindex + '].tab'] = 1;
    newdata['eles[' + compindex + '].sortKey'] = 'sales';
    newdata['eles[' + compindex + '].sortDirection'] = 0;
    newdata['eles[' + goods_compindex + '].curpage'] = 0;
    newdata['eles[' + goods_compindex + '].is_more'] = 1;
    newdata['eles[' + goods_compindex + '].goods_data'] = [];
    newdata['eles[' + goods_compindex + '].param'] = param;

    pageInstance.setData(newdata);

    pageInstance.callComponentMethod({
      componentIndex: goods_compindex,
      methodName: '_goodsScrollFunc',
      argvs: [goods_compindex]
    });
  }

  // 筛选组件 按取货排序 tab = 3
  pickUpStyle = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];
    if (compData.showPickUpBox){
      newdata['eles[' + compindex + '].pickUpObj'] = compData.initPickUpObj;
      newdata['eles[' + compindex + '].showPickUpBox'] = false;
      pageInstance.setData(newdata);
      return;
    }
    let pickUpObj = compData.pickUpObj || { '1': 1, '2': 2, '3': 3 , '4':4};
    let initPickUpObj = JSON.parse(JSON.stringify(pickUpObj));
    
    // 先处理子店显示点餐类型
    let goods_compindex = app.findComponentIndexById(compData.customFeature.addGroup_object);
    let goods_customFeature = goods_compindex > -1 ? pageInstance.data.eles[goods_compindex].customFeature : {};

    app.getAppECStoreConfig((res) => {
      newdata['eles[' + compindex + '].tabExpress'] = res.express;
      newdata['eles[' + compindex + '].tabIntraCity'] = res.intra_city;
      newdata['eles[' + compindex + '].tabDelivery'] = res.is_self_delivery;
      newdata['eles[' + compindex + '].tabDining'] = res.dining;

      // 子店不显示点餐类型
      if (goods_customFeature.form === 'goods' && goods_customFeature.isShowFranchiseeGoods){
        newdata['eles[' + compindex + '].tabDining'] = false;
        pickUpObj = compData.pickUpObj || { '1': 1, '2': 2, '3': 3 };
        initPickUpObj = JSON.parse(JSON.stringify(pickUpObj));
      }

      newdata['eles[' + compindex + '].initPickUpObj'] = initPickUpObj;
      newdata['eles[' + compindex + '].pickUpObj'] = pickUpObj;
      newdata['eles[' + compindex + '].tab'] = 3;
      newdata['eles[' + compindex + '].showPickUpBox'] = true;

      pageInstance.setData(newdata);
    });
  }

  // 筛选组件 按价格排序 tab = 2
  sortByPrice = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];
    let sd = compData.sortDirection;
    let addGroup_object = compData.customFeature.addGroup_object;

    let goods_compindex = app.findComponentIndexById(addGroup_object);
    if (goods_compindex === -1) {
      app.showModal({
        content: '找不到关联的列表'
      });
      return;
    }
    
    sd = (!sd || sd == 0) ? 1 : 0;

    let param = pageInstance.data.eles[goods_compindex].param;
    param.sort_key = 'price';
    param.sort_direction = sd;

    newdata['eles[' + compindex + '].tab'] = 2;
    newdata['eles[' + compindex + '].sortKey'] = 'price';
    newdata['eles[' + compindex + '].sortDirection'] = sd;
    newdata['eles[' + goods_compindex + '].curpage'] = 0;
    newdata['eles[' + goods_compindex + '].is_more'] = 1;
    newdata['eles[' + goods_compindex + '].goods_data'] = [];
    newdata['eles[' + goods_compindex + '].param'] = param;

    pageInstance.setData(newdata);

    pageInstance.callComponentMethod({
      componentIndex: goods_compindex,
      methodName: '_goodsScrollFunc',
      argvs: [goods_compindex]
    });
  }

  // 筛选组件 展示侧边筛选
  filterList = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    pageInstance.setData({
      filterShow: true,
      filterCompindex: compindex
    });
    pageInstance.filterRef.current.show({
      filterShow: true,
      chooseCateId: pageInstance.data.categoryId,
      form: pageInstance.data.classifyGroupForm,
      confirm: (e) => {
        this.filterConfirm(e);
      }
    })
  }

  selectPickUp = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newdata = {};
    let pickType = e.currentTarget.dataset.type;
    let pickUpObj = pageInstance.data.eles[compindex].pickUpObj;
    pickUpObj[pickType] = pickUpObj[pickType] ? '' : pickType;

    newdata['eles[' +compindex + '].pickUpObj'] = pickUpObj;

    pageInstance.setData(newdata);
  }

  resetPickBtn = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newdata = {};
    let pickUpObj = { '1': 1, '2': 2, '3': 3 , '4':4};

    // 先处理子店显示点餐类型
    let compData = pageInstance.data.eles[compindex];
    let goods_compindex = app.findComponentIndexById(compData.customFeature.addGroup_object);
    let goods_customFeature = goods_compindex > -1 ? pageInstance.data.eles[goods_compindex].customFeature : {};
    // 子店不显示点餐类型
    if (goods_customFeature.form === 'goods' && goods_customFeature.isShowFranchiseeGoods) {
      pickUpObj = { '1': 1, '2': 2, '3': 3 };
    }

    newdata['eles[' + compindex + '].pickUpObj'] = pickUpObj;

    pageInstance.setData(newdata);
  }

  surePickBtn = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];
    let addGroup_object = compData.customFeature.addGroup_object;

    let goods_compindex = app.findComponentIndexById(addGroup_object);
    if (goods_compindex === -1) {
      app.showModal({
        content: '找不到关联的列表'
      });
      return;
    }

    let pickType = compData.pickUpObj;
    let pickUpArr = [];
    for (let i in pickType){
      pickType[i] &&  pickUpArr.push(pickType[i]);
    }

    let param = pageInstance.data.eles[goods_compindex].param;
    param.pick_up_type = pickUpArr;

    newdata['eles[' + compindex + '].showPickUpBox'] = false;
    newdata['eles[' + goods_compindex + '].curpage'] = 0;
    newdata['eles[' + goods_compindex + '].is_more'] = 1;
    newdata['eles[' + goods_compindex + '].goods_data'] = [];
    newdata['eles[' + goods_compindex + '].param'] = param;

    pageInstance.setData(newdata);

    pageInstance.callComponentMethod({
      componentIndex: goods_compindex,
      methodName: '_goodsScrollFunc',
      argvs: [goods_compindex]
    });
  }

    
  // 筛选侧栏确定
  filterConfirm = (e) => {
    let detail = e.detail;
    let hasFilter = (detail.leastPrice || detail.mostPrice || detail.chooseCateId || detail.currentRegionId) ?  true : false;
    let pageInstance = app.getAppCurrentPage();
    let compindex = pageInstance.data.filterCompindex;
    let newdata = {};
    let addGroup_object = pageInstance.data.eles[compindex].customFeature.addGroup_object;

    let goods_compindex = app.findComponentIndexById(addGroup_object);
    if (goods_compindex === -1) {
      app.showModal({
        content: '找不到关联的列表'
      });
      return;
    }
    let idx = detail.chooseCateId ? {
      idx: 'category',
      idx_value: detail.chooseCateId
    } : '';
    let param = pageInstance.data.eles[goods_compindex].param;
    param.least_price = detail.leastPrice || '';
    param.most_price = detail.mostPrice || '';
    param.region_id = detail.currentRegionId || '';
    param.idx_arr = idx;

    newdata['eles[' + compindex + '].hasFilter'] = hasFilter;
    newdata['eles[' + goods_compindex + '].curpage'] = 0;
    newdata['eles[' + goods_compindex + '].is_more'] = 1;
    newdata['eles[' + goods_compindex + '].goods_data'] = [];
    newdata['eles[' + goods_compindex + '].param'] = param;

    pageInstance.setData(newdata);

    pageInstance.callComponentMethod({
      componentIndex: goods_compindex,
      methodName: '_goodsScrollFunc',
      argvs: [goods_compindex]
    });
  }

  hideFilterPickUpBox = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].pickUpObj'] = pageInstance.data.eles[compindex].initPickUpObj;
    newdata['eles[' + compindex + '].showPickUpBox'] = false;
    pageInstance.setData(newdata);
  }

  turnToSearchPage = (e) => {
    app.turnToSearchPage(e);
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    const searchStyleObj = convertStyleData(customFeature.searchStyle.style);
    const sortStyleObj = convertStyleData(customFeature.sortStyle.style);
    const colorStyleObj = {
      color: customFeature.selectedColor
    };
    const sortColorStyleObj = {
      color: customFeature.sortStyle.style.color
    };
    const backgroundStyleObj = {
      background: customFeature.selectedColor
    };
    /**
     *  组件内容处理
     */   
    let content = data.content;
    /**
     * 返回组件
     */ 
    return (
      <React.Fragment>
        <div className="custom-component filter" style={styleObj}>
          <div className="search-wrap">
            <div className="search-inner" style={searchStyleObj}
              onClick={this.turnToSearchPage}
              data-form="goods"
              data-compindex={this.props.index}
              data-listid={customFeature.addGroup_object}
              >
              <span className="ico-moon icon-search"></span>
              { customFeature.placeholder }
            </div>
          </div>
          <div className="tab-wrap" style={sortStyleObj}>
            <div className="tab-item"
              style={ data.tab == 0 ? colorStyleObj : null }
              onClick={this.sortByDefault}
              data-compindex={this.props.index}
              >综合</div>
            <div className="tab-item"
              style={ data.tab == 1 ? colorStyleObj : null }
              onClick={this.sortBySales}
              data-compindex={this.props.index}
              >销量</div>
            <div className="tab-item pick-up"
              style={ data.tab == 3 ? colorStyleObj : null }
              onClick={this.pickUpStyle}
              data-compindex={this.props.index}
              >取货
              <span className="filter-down"></span>
            </div>
            <div className="tab-item tab-price"
              style={ data.tab == 2 ? colorStyleObj : null }
              onClick={this.sortByPrice}
              data-compindex={this.props.index}
              >价格
              <div className="label">
                <span className="filter-up"
                  style={ data.tab == 2 && data.sortDirection == 1 ? colorStyleObj : sortColorStyleObj }></span>
                <span className="filter-down"
                  style={ data.tab == 2 && data.sortDirection == 0 ? colorStyleObj : sortColorStyleObj }></span>
              </div>
            </div>
            <div className="tab-item"
              style={ data.hasFilter ? colorStyleObj : null }
              onClick={this.filterList}
              data-compindex={this.props.index}
              >筛选
              <span className="ico-moon icon-filter-f"></span>
            </div>
          </div>
          {
            data.showPickUpBox &&
            <div className="pick-up-box">
              <div className="pick-style-content">
                {
                  data.tabExpress == 1 &&
                  <div style={ data.pickUpObj[1] ? colorStyleObj : null }
                    onClick={this.selectPickUp}
                    data-type="1"
                    data-compindex={this.props.index}
                    >快递
                    <span className="pick-bottom-line"
                      style={ data.pickUpObj[1] ? backgroundStyleObj : null }></span>
                    {
                      data.pickUpObj[1] && <span className="ico-moon icon-gou"></span>
                    }
                  </div>
                }
                {
                  data.tabDelivery == 1 &&
                  <div style={ data.pickUpObj[3] ? colorStyleObj : null }
                    onClick={this.selectPickUp}
                    data-type="3"
                    data-compindex={this.props.index}
                    >上门自提
                    <span className="pick-bottom-line"
                      style={ data.pickUpObj[3] ? backgroundStyleObj : null }></span>
                    {
                      data.pickUpObj[3] && <span className="ico-moon icon-gou"></span>
                    }
                  </div>
                }
                {
                  data.tabIntraCity == 1 &&
                  <div style={ data.pickUpObj[2] ? colorStyleObj : null }
                    onClick={this.selectPickUp}
                    data-type="2"
                    data-compindex={this.props.index}
                    >同城配送
                    <span className="pick-bottom-line"
                      style={ data.pickUpObj[2] ? backgroundStyleObj : null }></span>
                    {
                      data.pickUpObj[2] && <span className="ico-moon icon-gou"></span>
                    }
                  </div>
                }
                {
                  data.tabDining == 1 &&
                  <div style={ data.pickUpObj[4] ? colorStyleObj : null }
                    onClick={this.selectPickUp}
                    data-type="4"
                    data-compindex={this.props.index}
                    >堂食点餐
                    <span className="pick-bottom-line"
                      style={ data.pickUpObj[4] ? backgroundStyleObj : null }></span>
                    {
                      data.pickUpObj[4] && <span className="ico-moon icon-gou"></span>
                    }
                  </div>
                }
              </div>
              <div className="pick-btn-content">
                <span onClick={this.resetPickBtn} data-compindex={this.props.index}>重置</span>
                <span className="sure-pick-btn"
                  style={{
                    background: customFeature.selectedColor
                  }}
                  onClick={this.surePickBtn}
                  data-compindex={this.props.index}
                  >确定</span>
              </div>
            </div>
          }
        </div>
        {
          data.showPickUpBox &&
          <div className="custom-component filter pick-up-mask" onClick={this.hideFilterPickUpBox}></div>
        }
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/filter-custom-component/FilterCustomComponent.jsx